import SquareForm from './SquareForm';

export default SquareForm;
